import axios from './axios'
import NProgress from 'nprogress'
import { Result } from './model'

// 不可枚举附加响应元信息（status / 请求url / 请求体）：
// 不影响 JSON.stringify / Object.keys / 展开等既有用法，老调用方零感知
function attachResMeta(data: any, meta: { status?: number; url?: string; params?: unknown }) {
  if (data && typeof data === 'object') {
    Object.defineProperty(data, '__resMeta', {
      value: meta,
      enumerable: false,
      configurable: true
    })
  }
  return data
}

interface Reauest {
  responseType: string
  get<T>(url: string, params?: unknown): Promise<Result<T>>
  post<T>(url: string, params?: unknown, responseType?: any): Promise<Result<T>>
  upload<T>(url: string, params: unknown): Promise<Result<T>>
  download(url: string): void
}

const request: Reauest = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .get(url, { params })
        .then((res) => {
          NProgress.done()
          // res 可能为空（错误拦截器未 re-throw），判空原样 resolve，不挂 meta
          resolve(
            attachResMeta(res?.data, {
              status: res?.status,
              url: res?.request?.responseURL || res?.config?.url,
              params: res?.config?.data
            })
          )
        })
        .catch((err) => {
          NProgress.done()
          reject(
            attachResMeta(err?.data, {
              status: err?.response?.status,
              url: err?.config?.url,
              params: err?.config?.data
            })
          )
        })
    })
  },
  post(url, obj?: any, isArraybuffer?) {
    const { switchApi, ...params } = obj || {}
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(switchApi || url, JSON.stringify(params), { responseType: isArraybuffer ? 'arraybuffer' : 'json' })
        .then((res) => {
          NProgress.done()
          // res 可能为空（错误拦截器未 re-throw），判空原样 resolve，不挂 meta
          resolve(
            attachResMeta(res?.data, {
              status: res?.status,
              url: res?.request?.responseURL || res?.config?.url,
              params: res?.config?.data
            })
          )
        })
        .catch((err) => {
          NProgress.done()
          reject(
            attachResMeta(err?.data, {
              status: err?.response?.status,
              url: err?.config?.url,
              params: err?.config?.data
            })
          )
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(url, file, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          NProgress.done()
          // res 可能为空（错误拦截器未 re-throw），判空原样 resolve，不挂 meta
          resolve(
            attachResMeta(res?.data, {
              status: res?.status,
              url: res?.request?.responseURL || res?.config?.url,
              params: res?.config?.data
            })
          )
        })
        .catch((err) => {
          NProgress.done()
          reject(
            attachResMeta(err?.data, {
              status: err?.response?.status,
              url: err?.config?.url,
              params: err?.config?.data
            })
          )
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  },
  responseType: ''
}
export default request
